module.exports = __webpack_public_path__ + "img/consultoria2_4-3_1024.51fc7d80.jpg";